import 'bootstrap/dist/css/bootstrap.min.css';
import './src/assets/css/styles.scss';
import { trackPageView } from './src/services/analytics';

export const onRouteUpdate = ({ location }) => trackPageView({ pagePath: location.pathname });
